module.exports = __webpack_public_path__ + "static/media/chanpinfuwu.4338dcd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/chanpinfuwu.png
// module id = 745
// module chunks = 0